import { defineStore } from "pinia";
import { getSeoData } from "../services/seo";

interface SeoData {
    trip?: string;
    destination?: string;
    activity?: string;
    post_category?: string;
    client_account?: string;
    post?: string;
    page?: string;
    is_breadcrumb_enabled?: boolean;
    breadcrumb_separator?: string;
    homepage_label?: string;
}

let inFlight: Promise<void> | null = null;

export const useSeoStore = defineStore("seo", {
    state: () => ({
        seoData: null as SeoData | null,
    }),
    getters: {

    },
    actions: {
        async dispatchGetSeoData(force = false): Promise<void> {
            if (this.seoData && !force) return;
            if (inFlight) return inFlight;
            inFlight = (async () => {
                try {
                    const response = await getSeoData();
                    if (response) this.seoData = response.data.data;
                } finally {
                    inFlight = null;
                }
            })();
            return inFlight;
        },
    },
});
